/**
 * ゼロ幅スペース文字列を表す定数
 */
export const ZWSP = '\u200B';

/**
 * 改行文字列を表す定数
 */
export const NEWLINE = '\n';
